import { Injectable } from '@angular/core';

import { Option, OptionMarket, OptionMarketStatus, OptionStatus, Price } from '@cds/betting-offer';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

import { HorsesFixtureHelper } from './horses-fixture-helper.service';

@Injectable({
    providedIn: 'root',
})
export class FixtureFreeformedPricingHelper {
    isPriceLocked(fixture: WinGameFixture, optionMarket: OptionMarket, option: Option, optionPrice: Price): boolean {
        if (!HorsesFixtureHelper.isTradable(fixture)) {
            return true;
        }

        if (optionMarket.status !== OptionMarketStatus.Visible) {
            return true;
        }

        if (option.status !== OptionStatus.Visible) {
            return true;
        }

        if (!this.isValid(optionPrice)) {
            return true;
        }

        return false;
    }

    private isValid(price: Price): boolean {
        return (price && price.odds && price.odds > 1) || false;
    }
}
